import React from 'react';
import classNames from 'classnames';

import styles from './Spinner.module.scss';

export const Spinner = ({ rounded, overlay = false }) => (
  <div
    className={classNames({
      [styles.spinnerOverlay]: overlay,
    })}
  >
    <div
      className={classNames({
        [styles.spinner]: !rounded,
        [styles.rounded]: rounded,
      })}
    />
  </div>
);
